<template>
  <div class="page-container">
    <!-- 统计 -->
    <div class="stat-row">
      <el-card shadow="never" class="stat-card">
        <div class="stat-num" style="color:#FF7D00">{{ stat.pending }}</div>
        <div class="stat-label">待派单</div>
      </el-card>
      <el-card shadow="never" class="stat-card">
        <div class="stat-num" style="color:#165DFF">{{ stat.processing }}</div>
        <div class="stat-label">处理中</div>
      </el-card>
      <el-card shadow="never" class="stat-card">
        <div class="stat-num" style="color:#00B42A">{{ stat.done }}</div>
        <div class="stat-label">已完成</div>
      </el-card>
    </div>

    <el-card shadow="never">
      <div class="card-head">
        <span class="card-title">运维工单</span>
        <div class="filters">
          <el-select v-model="filters.status" placeholder="状态" clearable @change="load" style="width:120px">
            <el-option label="待派单" :value="0"></el-option>
            <el-option label="处理中" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
          </el-select>
          <el-select v-model="filters.type" placeholder="类型" clearable @change="load" style="width:120px">
            <el-option label="故障" value="故障"></el-option>
            <el-option label="保养" value="保养"></el-option>
            <el-option label="巡检" value="巡检"></el-option>
          </el-select>
          <el-input v-model="filters.keyword" placeholder="工单号/设备/描述" clearable @keyup.enter="load" style="width:200px"></el-input>
          <el-button type="primary" @click="openCreate">新建工单</el-button>
        </div>
      </div>

      <el-table :data="list" v-loading="loading" border stripe height="100%">
        <el-table-column prop="id" label="工单号" min-width="160"></el-table-column>
        <el-table-column prop="device" label="设备" min-width="110"></el-table-column>
        <el-table-column prop="type" label="类型" width="90">
          <template slot-scope="{row}">
            <el-tag size="mini" :type="row.type === '故障' ? 'danger' : (row.type === '保养' ? 'warning' : 'info')">{{ row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="优先级" width="90">
          <template slot-scope="{row}">
            <el-tag size="mini" :type="priTag(row.priority)">{{ priText(row.priority) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="{row}">
            <el-tag size="mini" :type="statusTag(row.status)">{{ statusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="assignee" label="负责人" width="100"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="160"></el-table-column>
        <el-table-column label="操作" min-width="200" fixed="right">
          <template slot-scope="{row}">
            <el-button
              v-if="row.status === 0"
              type="text"
              @click="openDispatch(row)"
            >派单</el-button>
            <el-button
              v-if="row.status === 1"
              type="text"
              @click="process(row)"
            >处理</el-button>
            <el-button
              v-if="row.status === 1"
              type="text"
              @click="close(row)"
            >闭环</el-button>
            <el-button type="text" @click="view(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新建工单 -->
    <el-dialog title="新建工单" :visible.sync="createVisible" width="480px">
      <el-form :model="createForm" label-width="80px">
        <el-form-item label="设备">
          <el-select v-model="createForm.device" filterable placeholder="选择设备" style="width:100%">
            <el-option v-for="d in deviceOptions" :key="d.id" :label="d.name + ' / ' + d.sn" :value="d.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="createForm.type">
            <el-radio label="故障">故障</el-radio>
            <el-radio label="保养">保养</el-radio>
            <el-radio label="巡检">巡检</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优先级">
          <el-select v-model="createForm.priority" style="width:100%">
            <el-option label="低" :value="1"></el-option>
            <el-option label="中" :value="2"></el-option>
            <el-option label="高" :value="3"></el-option>
            <el-option label="紧急" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="createForm.desc" type="textarea" :rows="3" placeholder="故障/保养/巡检说明"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitCreate">提交</el-button>
      </span>
    </el-dialog>

    <!-- 派单 -->
    <el-dialog title="派单" :visible.sync="dispatchVisible" width="420px">
      <el-form label-width="80px">
        <el-form-item label="工单号">
          <span>{{ current.id }}</span>
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="dispatchForm.assignee" placeholder="选择负责人" style="width:100%">
            <el-option v-for="a in operators" :key="a" :label="a" :value="a"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dispatchVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitDispatch">确定派单</el-button>
      </span>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog title="工单详情" :visible.sync="detailVisible" width="460px">
      <el-descriptions :column="1" border v-if="current.id">
        <el-descriptions-item label="工单号">{{ current.id }}</el-descriptions-item>
        <el-descriptions-item label="设备">{{ current.device }}</el-descriptions-item>
        <el-descriptions-item label="SN">{{ current.sn }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ current.type }}</el-descriptions-item>
        <el-descriptions-item label="优先级">{{ priText(current.priority) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ statusText(current.status) }}</el-descriptions-item>
        <el-descriptions-item label="负责人">{{ current.assignee }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ current.created_at }}</el-descriptions-item>
        <el-descriptions-item label="完成时间">{{ current.finished_at || '—' }}</el-descriptions-item>
        <el-descriptions-item label="描述">{{ current.desc }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getWorkOrders, createWorkOrder, dispatchWorkOrder, processWorkOrder, closeWorkOrder, getWorkOrderDevices } from '@/api/sentinel'

export default {
  name: 'WorkOrderIndex',
  data() {
    return {
      stat: { pending: 0, processing: 0, done: 0 },
      filters: { status: '', type: '', keyword: '' },
      list: [],
      loading: false,
      deviceOptions: [],
      operators: ['王强', '李伟', '赵敏', '陈刚', '孙磊', '周婷', '蒋琳', '郑凯', '韩冰', '冯雪'],
      createVisible: false,
      dispatchVisible: false,
      detailVisible: false,
      saving: false,
      current: {},
      createForm: { device: '', type: '故障', priority: 2, desc: '' },
      dispatchForm: { assignee: '' }
    }
  },
  created() {
    this.loadDevices()
    this.load()
  },
  methods: {
    loadDevices() {
      getWorkOrderDevices().then(res => { this.deviceOptions = res.data.list })
    },
    load() {
      this.loading = true
      getWorkOrders(this.filters).then(res => {
        this.list = res.data.list
        this.stat = res.data.stat
        this.loading = false
      })
    },
    openCreate() {
      this.createForm = { device: '', type: '故障', priority: 2, desc: '' }
      this.createVisible = true
    },
    submitCreate() {
      if (!this.createForm.device) { this.$message.warning('请选择设备'); return }
      this.saving = true
      createWorkOrder(this.createForm).then(() => {
        this.$message.success('工单已创建')
        this.saving = false
        this.createVisible = false
        this.load()
      }).catch(() => { this.saving = false })
    },
    openDispatch(row) {
      this.current = row
      this.dispatchForm = { assignee: '' }
      this.dispatchVisible = true
    },
    submitDispatch() {
      if (!this.dispatchForm.assignee) { this.$message.warning('请选择负责人'); return }
      this.saving = true
      dispatchWorkOrder(this.current.id, this.dispatchForm).then(() => {
        this.$message.success('已派单给 ' + this.dispatchForm.assignee)
        this.saving = false
        this.dispatchVisible = false
        this.load()
      }).catch(() => { this.saving = false })
    },
    process(row) {
      this.$confirm('确认开始处理工单 ' + row.id + '？', '提示', { type: 'warning' }).then(() => {
        processWorkOrder(row.id, {}).then(() => { this.$message.success('已更新为处理中'); this.load() })
      }).catch(() => {})
    },
    close(row) {
      this.$confirm('确认闭环工单 ' + row.id + '？', '提示', { type: 'warning' }).then(() => {
        closeWorkOrder(row.id, {}).then(() => { this.$message.success('工单已闭环'); this.load() })
      }).catch(() => {})
    },
    view(row) {
      this.current = row
      this.detailVisible = true
    },
    statusText(s) { return ['待派单', '处理中', '已完成'][s] || '—' },
    statusTag(s) { return ['warning', 'primary', 'success'][s] || 'info' },
    priText(p) { return ['', '低', '中', '高', '紧急'][p] || '—' },
    priTag(p) { return ['', 'info', '', 'warning', 'danger'][p] || 'info' }
  }
}
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.stat-row {
  display: flex;
  gap: 14px;
}
.stat-card {
  flex: 1;
  border-radius: 10px;
  text-align: center;
}
.stat-num {
  font-size: 30px;
  font-weight: 700;
}
.stat-label {
  font-size: 13px;
  color: #86909C;
  margin-top: 4px;
}
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  flex-wrap: wrap;
  gap: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1D2129;
}
.filters {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
